module.exports = {

    // class SystemType(object):
    //     ONE_TO_ONE  = 1
    //     GROUP_CHAT  = 2
    //     PROJECT_DISCUSSION = 3

    systemType: {
        USER: 1,
        GROUP: 2,
        PROJECT_DISCUSSION: 3
    },

    isUserChat(systemType) {
        return systemType === 1;
    },

    isGroupChat(systemType) {
        return systemType === 2;
    }
};